module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Edit {section}":"Edit {section}"},"de":{"Edit {section}":"{section} bearbeiten"}}')
  delete Component.options._Ctor
}
